<div class="event-checkout-dialog">
    <div class="text-right pr-20">
        <i class="fa fa-times" aria-hidden="true" (click)="closeModal()"></i>
    </div>
    <div class="modal-body text-center">
        <p class="fs-18 fw-400 modal-text">Please open the link in the browser and login to proceed for the {{type}}
            payment.</p>
        <div class="bg-gray text-left ff mt-4 d-flex align-items-center">
            <textarea (click)="openIn()">{{copyLink}}</textarea>
            <button class="copy-btn" id="btnCopyClip" (click)="copyToClipboard('text-area')">COPY</button>
        </div>
        <p class="fs-12 pt-30">Note: After completion of payment click the refresh icon to update the payment status.<i
                class="fa fa-refresh fs-14 pl-15 pointer" aria-hidden="true" (click)="reload()"></i>
        </p>
    </div>
</div>